//
// File link
//
// This script is handling download events for Adobe analytics
// ---------------------------------------------------------------------------

'use strict';

$(document).ready(function () {
    $(document).on('click', '.js-download-event', function () {
        let analyticsFileName = $(this).data('analytics-filename');

        window.rs.web.digitalData.event = window.rs.web.digitalData.event ? window.rs.web.digitalData.event : [];

        window.rs.web.digitalData.event.push({
            eventInfo: {
                download_name: analyticsFileName
            }
        });

        window._satellite.track('ds_download');
    });
});



// WEBPACK FOOTER //
// ./src/js/components/file-link.js